// Default settings structure
const defaultSettings = {
	builder_support: {
		gutenberg: {
			enabled: true,
			auto_detect: true,
			custom_blocks: true,
		},
		elementor: {
			enabled: false,
			auto_detect: true,
			widgets: {
				text_marquee: true,
				news_ticker: true,
				infinite_slider: true,
			},
		},
		bricks: {
			enabled: false,
			auto_detect: true,
			elements: {
				text_marquee: true,
				news_ticker: true,
				infinite_slider: true,
			},
		},
		shortcode: {
			enabled: true,
			auto_detect: true,
			shortcodes: {
				text_marquee: true,
				news_ticker: true,
				infinite_slider: true,
			},
		},
	},
	performance: {
		lazy_loading: true,
		minify_css: true,
		cache_styles: true,
	},
	compatibility: {
		theme_compatibility: true,
		plugin_compatibility: true,
		responsive_breakpoints: {
			mobile: 480,
			tablet: 1024,
			desktop: 1200,
		},
	},
};

// Get initial settings from window object or use defaults
const getInitialSettings = () => {
	if (window.marqueexAdminData?.settings) {
		return { ...defaultSettings, ...window.marqueexAdminData.settings };
	}
	return defaultSettings;
};

function reducer(
	state = {
		settings: getInitialSettings(),
		updating: false,
		loading: false,
		error: '',
		testResults: {},
	},
	action = {}
) {
	switch (action.type) {
		case 'FETCH_SETTINGS_PENDING':
			return {
				...state,
				loading: true,
				error: '',
			};
		case 'FETCH_SETTINGS_SUCCESS':
			return {
				...state,
				loading: false,
				settings: { ...defaultSettings, ...action.settings },
			};
		case 'FETCH_SETTINGS_ERROR':
			return {
				...state,
				loading: false,
				error: action.error || '',
			};
		case 'UPDATE_SETTINGS_PENDING':
			return {
				...state,
				updating: true,
				error: '',
			};
		case 'UPDATE_SETTINGS_SUCCESS':
			return {
				...state,
				updating: false,
				settings: action.settings, // Use the returned settings directly
			};
		case 'UPDATE_SETTINGS_ERROR':
			return {
				...state,
				updating: false,
				error: action.error || '',
			};
		case 'TEST_BUILDER_PENDING':
			return {
				...state,
				testResults: {
					...state.testResults,
					[action.builder]: { status: 'testing', message: 'Testing...' },
				},
			};
		case 'TEST_BUILDER_SUCCESS':
			return {
				...state,
				testResults: {
					...state.testResults,
					[action.builder]: action.result,
				},
			};
		case 'TEST_BUILDER_ERROR':
			return {
				...state,
				testResults: {
					...state.testResults,
					[action.builder]: {
						status: 'error',
						message: action.error || 'Test failed'
					},
				},
			};
		default:
			return state;
	}
}

export default reducer;
